export default "__VITE_ASSET__DwzrKcox__"